import { http, HttpResponse, type RequestHandler } from 'msw'
import { getApiRoute } from '@core/utils/api'

import {
  postUserPasswordResetRequestConfig,
  postUserPasswordResetValidateConfig,
  postUserPasswordResetConfirmConfig,
  getUserProfileConfig,
} from '@services/User/api'

import { profileMock } from '@services/User/mocks'

export const postUserPasswordResetRequestHandler: RequestHandler = http.post(
  getApiRoute(postUserPasswordResetRequestConfig.url),
  () => HttpResponse.json(),
)

export const postPasswordResetValidateHandler: RequestHandler = http.post(
  getApiRoute(postUserPasswordResetValidateConfig.url),
  () => HttpResponse.json(),
)

export const postPasswordResetConfirmHandler: RequestHandler = http.post(
  getApiRoute(postUserPasswordResetConfirmConfig.url),
  () => HttpResponse.json({ token: 'token', token_ttl: 180 }),
)

export const postPasswordResetConfirmHandlerErrorInvalidCode: RequestHandler = http.post(
  getApiRoute(postUserPasswordResetConfirmConfig.url),
  () => HttpResponse.json({ error: { detail: 'Invalid code', status: 400 } }, { status: 400 }),
)

export const getUserProfileHandler: RequestHandler = http.get(
  getApiRoute(getUserProfileConfig.url),
  () => HttpResponse.json(JSON.stringify(profileMock)),
)

export default [
  postUserPasswordResetRequestHandler,
  postPasswordResetValidateHandler,
  postPasswordResetConfirmHandler,
  getUserProfileHandler,
]
